import { create } from "sheetly";
export let text = ".input{max-width:7rem}.result-item{box-sizing:border-box}.cover-container{border:8px solid var(--difficulty);cursor:pointer}.cover-container img.cover{width:64px;height:64px}.charts{display:flex;flex-wrap:wrap;gap:1rem}";
export const sheet = create(text, import.meta.url);
